import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import dataStatisticData from '../datas/data-statistic'
export default {
  cpsPaymentList (ctx, data) {
    return fetch.cpsPaymentList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = dataStatisticData.cpsPaymentList(result.data)
      return result
    })
  },
  // 导出CPS缴费订单
  exportCpsPaymentList (ctx, data) {
    return fetch.exportCpsPaymentList(data).then(res => {
    //   let result = downloadFilename(res)
      return res
    })
  },
  findBranchCompany (ctx) {
    return fetch.findBranchCompany().then(res => {
      return res
    })
  },
  isCompanyValide (ctx) {
    return fetch.isCompanyValide().then(res => {
      return res
    })
  }
}
